@if (birthdayMembers) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title class="title-with-icon">
        <mat-icon>cake</mat-icon>
        Jarigen
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @for (m of birthdayMembers; track m) {
        <app-member-summary
          [member]="m.member"
          [extraData]="m.fromNowLabel"
          (click)="goToMember(m.member)"
          [showAge]="true"
          >
        </app-member-summary>
      }
      @if (birthdayMembers.length === 0) {
        <div class="alert alert-warning">
          <p>Niemand gevonden die binnenkort jarig is.</p>
        </div>
      }
    </mat-card-content>
  </mat-card>
}

